import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorMotherBoardsChips,
  fetchProcessorMotherBoardsAttributes,
  fetchProcessorMotherBoardsChipsById,
  updateProcessorMotherBoardsChips,
  updateStatusInProcessorMotherBoardsChips,
} from "./thunk";

interface CategoryState {
  processor_motherboardschips_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_motherboardschips_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_motherboards_chips",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorMotherBoardsAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMotherBoardsAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_motherboardschips_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorMotherBoardsAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorMotherBoardsChipsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMotherBoardsChipsById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorMotherBoardsChipsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorMotherBoardsChips.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_motherboardschips_list = state.processor_motherboardschips_list.map((processor_motherboards_chips) =>
          processor_motherboards_chips.id === action.payload.id ? action.payload : processor_motherboards_chips
        );
      })
      .addCase(addProcessorMotherBoardsChips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
      })
      .addCase(updateProcessorMotherBoardsChips.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_motherboardschips_list = state.processor_motherboardschips_list.map((processor_motherboards_chips) =>
          processor_motherboards_chips.id === action.payload.id ? action.payload : processor_motherboards_chips
        );
      })
      .addCase(updateProcessorMotherBoardsChips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
      })
      .addCase(updateStatusInProcessorMotherBoardsChips.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorMotherBoardsChips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
